const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	HEADER_HEIGHT: 70,
	TABLE_PAGE_SIZES: [15, 50, 100],
	DEFAULT_LANGUAGE: 'PL',
	ADMIN_DEFAULT_ROLE_ID: crypto.randomUUID(),
	TEXTAREA_MAX_LENGTH: 5000,
	ARTICLE_LENGTH_MAX: 1_000_000,
	SESSION_STORAGE_KEYS: {
		REFRESH_TOKEN: 'refreshToken',
		COMPONENT_VARIATIONS: {
			COMPONENT_ID: 'componentId',
		},
		CONTENT: {
			PAGE: 'content-page',
			LIMIT: 'content-limit',
			SEARCH: 'content-search',
			SORT: 'content-sort',
		},
		PRODUCT_TYPES: {
			PAGE: 'product-types-page',
			LIMIT: 'product-types-limit',
			SEARCH: 'product-types-search',
			SORT: 'product-types-sort',
		},
		ARTICLES: {
			PAGE: 'articles-page',
			LIMIT: 'articles-limit',
			SEARCH: 'articles-search',
			SORT: 'articles-sort',
		},
		COLORS: {
			PAGE: 'colors-page',
			LIMIT: 'colors-limit',
			SEARCH: 'colors-search',
			SORT: 'colors-sort',
			GROUP_ID: 'colors-group-id',
		},
		USERS: {
			PAGE: 'users-page',
			LIMIT: 'users-limit',
			SEARCH: 'users-search',
			SORT: 'users-sort',
		},
		ADMIN_LOGIN_EVENTS: {
			PAGE: 'admin-login-events-page',
			LIMIT: 'admin-login-events-limit',
			SEARCH: 'admin-login-events-search',
			SORT: 'admin-login-events-sort',
		},
		INVESTMENTS: {
			PAGE: 'investments-page',
			LIMIT: 'investments-limit',
			SEARCH: 'investments-search',
			SORT: 'investments-sort',
		},
		EXPORT_INVESTMENTS: {
			PAGE: 'export-investments-page',
			LIMIT: 'export-investments-limit',
			SEARCH: 'export-investments-search',
			SORT: 'export-investments-sort',
			STATUS: 'export-investments-status',
			USER_ID: 'export-investments-user-id',
			COMPANY_ID: 'export-investments-company-id',
			CREATED_AT: 'export-investments-created-at',
		},
	},
	CLIENT_COUNTRIES: [
		'Austria',
		'Belgia',
		'Białoruś',
		'Bośnia i Hercegowina',
		'Bułgaria',
		'Chorwacja',
		'Czarnogóra',
		'Dania',
		'Estonia',
		'Finlandia',
		'Francja',
		'Grecja',
		'Hiszpania',
		'Holandia',
		'Kosowo',
		'Litwa',
		'Łotwa',
		'Macedonia Północna',
		'Mołdawia',
		'Niemcy',
		'Norwegia',
		'Portugalia',
		'Republika Czeska',
		'Rumunia',
		'Serbia',
		'Słowacja',
		'Słowenia',
		'Szwajcaria',
		'Szwecja',
		'Turcja',
		'Ukraina',
		'Węgry',
		'Włochy',
	],
} as const;

export default APP_CONFIG;
